import { render, staticRenderFns } from "./NetworkParent.vue?vue&type=template&id=0e63d9e3&scoped=true"
import script from "./NetworkParent.vue?vue&type=script&lang=js"
export * from "./NetworkParent.vue?vue&type=script&lang=js"
import style0 from "./NetworkParent.vue?vue&type=style&index=0&id=0e63d9e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e63d9e3",
  null
  
)

export default component.exports